import { DropdownMenuItem, DropdownMenuShortcut } from '@/components/ui/dropdown-menu';
import { formatHotkey } from '@/shared/lib/hotkeys';

import type { MenuAction } from '../model/types';

interface MenuActionItemProps {
  action: MenuAction;
}

export const MenuActionItem = ({ action }: MenuActionItemProps) => {
  const Icon = action.icon;

  return (
    <DropdownMenuItem variant={action.variant} onClick={action.handler}>
      {Icon && <Icon />}
      {action.label}
      {action.hotkey && <DropdownMenuShortcut>{formatHotkey(action.hotkey)}</DropdownMenuShortcut>}
    </DropdownMenuItem>
  );
};
